import baseContainer from './baseContainer'

import commonNode from './commonNode'


export default {
    'mc-baseContainer': baseContainer,
    commonNode
}